<div class="legal-wrapper">
  <div class="legal-scroll-content">
    <div class="hero-background"></div>
    <div class="overlay"></div>

    <div class="legal-container">
      <div class="glass-card legal-card">
        
        <div class="legal-header">
          <h1>Privacy Policy</h1>
          <p class="last-updated">Last updated: September 7, 2026</p>
        </div>

        <div class="legal-body">
          
          <section>
            <h2>1. Introduction</h2>
            <p>
              <strong>YourNotes</strong> (“we”, “us”, or “our”) respects your privacy and is committed to protecting your personal data. 
              This Privacy Policy explains how we collect, use, store, and protect personal data when you use the YourNotes application 
              and website (the “Service”). We process personal data in accordance with the 
              <strong>General Data Protection Regulation (GDPR / AVG)</strong> and applicable Dutch law.
            </p>
          </section>

          <section>
            <h2>2. Who We Are (Data Controller)</h2>
            <p>
              YourNotes is the data controller responsible for processing your personal data.
            </p>
            <ul class="prohibited-list">
              <li><strong>Email:</strong> info [at] yournotes.nl</li>
              <li><strong>Website:</strong> <a href="https://www.yournotes.nl">yournotes.nl</a></li>
            </ul>
          </section>

          <section>
            <h2>3. Personal Data We Collect</h2>
            <p>We collect only the data necessary to provide and improve the Service.</p>
            
            <h3>3.1 Account Information</h3>
            <ul class="prohibited-list">
              <li>Name (if provided)</li>
              <li>Email address</li>
              <li>Login credentials (passwords are stored in hashed form)</li>
              <li>Mobile device ID</li>
            </ul>

            <h3>3.2 Calendar Data</h3>
            <p>If you connect a third‑party calendar (such as Google Calendar or Microsoft Outlook), we may access:</p>
            <ul class="prohibited-list">
              <li>Calendar events (titles, attendees, location, dates, and times)</li>
              <li>Related scheduling metadata</li>
            </ul>

            <h3>3.3 User consent</h3>
            <p>We may process information that you create, upload, or store in the Service, including notes, tasks, meeting summaries, attachments, and other content. This content may contain personal data, such as names, email addresses, phone numbers, or other information that users choose to include.</p>

            <h3>3.4 Usage and Technical Data</h3>
            <ul class="prohibited-list">
              <li>IP address, device and browser type</li>
              <li>Pages visited and feature usage</li>
            </ul>
          </section>

          <section>
            <h2>4. How We Use Your Data</h2>
            <p>We use personal data solely for legitimate and transparent purposes, including:</p>
            <ul class="prohibited-list">
              <li>Providing and maintaining the Service</li>
              <li>Displaying and managing your notes, tasks, and calendar data</li>
              <li>Send push notifications to your mobile app for tasks and events</li>
              <li>Authenticating users and securing accounts</li>
              <li>Share lists between YourNotes users</li>
              <li>Enable sending YourNotes to people you want to email</li>
              <li>Complying with legal obligations</li>
            </ul>
            <p><strong>We do not sell your personal data.</strong></p>
          </section>

          <section>
            <h2>5. Legal Basis for Processing (GDPR Article 6)</h2>
            <p>We process your data based on:</p>
            <ul class="prohibited-list">
              <li><strong>Performance of a contract:</strong> To provide the Service you request.</li>
              <li><strong>Consent:</strong> For connecting third‑party calendars.</li>
              <li><strong>Legitimate interests:</strong> To secure and improve the Service.</li>
              <li><strong>Legal obligations:</strong> Where required by law.</li>
            </ul>
          </section>

          <section>
            <h2>6. Calendar Integrations</h2>
            <p>
              When you connect a third‑party calendar, you grant us permission to access and display your data. 
              We primarily access data in <strong>read‑only mode</strong>. We only modify or create events if 
              you explicitly initiate those actions.
            </p>
          </section>

          <section>
            <h2>7. Data Sharing and Processors</h2>
            <p>
              We may share data with trusted processors (e.g., hosting providers). 
              These parties process data solely on our behalf and under contractual data processing agreements.
            </p>
          </section>

          <section>
            <h2>8. International Data Transfers</h2>
            <p>
              Where data is processed outside the EEA, we ensure appropriate safeguards, such as 
              Standard Contractual Clauses (SCCs).
            </p>
          </section>

          <section>
            <h2>9. Data Retention</h2>
            <p>
              Account data is retained while your account is active. Upon account deletion, 
              personal data is deleted or anonymized within a reasonable period, unless longer retention is required by law.
            </p>
          </section>

          <section>
            <h2>10. Your Rights Under GDPR</h2>
            <p>You have the right to:</p>
            <ul class="prohibited-list">
              <li><strong>Access & Rectification:</strong> Request a copy or correction of your data.</li>
              <li><strong>Erasure:</strong> Request deletion (“right to be forgotten”).</li>
              <li><strong>Portability:</strong> Receive your data in a structured format.</li>
              <li><strong>Withdrawal of consent:</strong> Disconnect services at any time.</li>
            </ul>
          </section>

          <section>
            <h2>11. Right to Lodge a Complaint</h2>
            <p>
              If you believe your rights have been violated, you can lodge a complaint with the 
              <strong>Autoriteit Persoonsgegevens</strong> (https://autoriteitpersoonsgegevens.nl).
            </p>
          </section>

          <section>
            <h2>12. Security Measures</h2>
            <p>
              We use encryption, access controls, and secure authentication. 
              However, no system is 100% secure; we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2>13. Cookies</h2>
            <p>
              We use essential cookies only for authentication and session management. 
              We do not use tracking cookies without explicit consent.
            </p>
          </section>

          <section>
            <h2>14. Children’s Privacy</h2>
            <p>The Service is not intended for children under 16. We do not knowingly collect their data.</p>
          </section>

          <section class="contact-section">
            <h2>15. Contact</h2>
            <p>For questions about your privacy, contact us at:</p>
            <a href="mailto:info@yournotes.nl" class="email-link">info [at] yournotes.nl</a>
          </section>

        </div>
      </div>
    </div>
  </div>

  <mat-toolbar class="bottom-toolbar">
    <button mat-flat-button (click)="back()">
      <mat-icon>arrow_back</mat-icon> Back
    </button>
  </mat-toolbar>
</div>